<div class="max-w-2xl mx-auto mt-8 bg-white shadow-lg rounded-2xl p-6">
  <h2 class="text-xl font-bold mb-4">Vendor Profile</h2>


  <div *ngIf="!vendor.isApproved" class="bg-yellow-100 text-yellow-800 p-3 rounded-xl mb-4">
    Your account is pending approval by admin.
  </div>


  <div *ngIf="editing" class="space-y-3">
    <input [(ngModel)]="vendor.storeName"
           class="w-full border rounded-xl px-3 py-2" placeholder="Store Name" />
<textarea [(ngModel)]="vendor.storeDescription"
          class="w-full border rounded-xl px-3 py-2" placeholder="Description"></textarea>
    <button (click)="save()" class="bg-green-600 text-white px-4 py-2 rounded-xl hover:bg-green-700">Save</button>
  </div>


  <div *ngIf="!editing">
    <p class="text-lg font-semibold">{{ vendor.storeName }}</p>
    <p class="text-gray-600">{{ vendor.storeDescription }}</p>
    <button (click)="editing = true" class="mt-3 bg-indigo-600 text-white px-4 py-2 rounded-xl hover:bg-indigo-700">
      Edit Profile
    </button>
  </div>


  <p *ngIf="message" class="mt-2 text-sm text-green-700">{{ message }}</p>
</div>
